import { dutchMonths, transformMonthFromDate } from './monthFormatter'

export const FIRST_AVAILABLE_YEAR = 2019

export const getArchiveCategories = () => {
  const now = new Date()
  const currentYear =
    now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()
  let year = currentYear
  const years = []

  while (year >= FIRST_AVAILABLE_YEAR) {
    years.push(year)
    year--
  }

  return years.map((year) => {
    let months = Array.from(Array(12).keys()).map((index) => {
      const code = transformMonthFromDate(`${year}-${index + 1}`)
      const label = dutchMonths[index]

      return {
        code,
        label,
      }
    })

    if (year === now.getFullYear()) {
      months = months.filter((_, index) => index < new Date().getMonth())
    }

    return {
      year,
      months,
    }
  })
}
